import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      user_Data: 'account/getCurrentUser',
    }),
    isAdmin() {
      if (this.user_Data.type_name === 'admin') {
        return true;
      }
      return false;
    },
  },
};
